module.exports = __webpack_public_path__ + "img/vehicle-options-white-chevy.97d8004b.png";